export default "__VITE_ASSET__3334748f__"